<div class="checkbox-wrapper" [class.disabled]="disabled">
  <!--
  Top label if exists
  -->
  @if (topLabel) {
    <span class="label">{{ topLabel }}</span>
  }
  <div
    #trigger
    class="checkbox"
    [attr.aria-disabled]="disabled"
    [class.checkbox--multi-line]="multiLine"
    (click)="!readonly && updateChanges(!value)"
  >
    <!--
    Checkmark
    -->
    <span
      class="checkmark"
      matRipple
      [matRippleColor]="rippleColor"
      [matRippleTrigger]="trigger"
      [matRippleCentered]="true"
      [matRippleDisabled]="disabled"
      [matRippleUnbounded]="true"
      [matRippleRadius]="28"
      [class.checkmark--active]="value"
      [class.checkmark--indeterminate]="indeterminate"
    ></span>
    <!--
    Label
    Followed by ngContent if provided
    -->
    <div class="text">{{ label }}<ng-content></ng-content></div>
  </div>
</div>
